/**
 * Centralized Logger Utility
 *
 * Provides logging functionality that:
 * - Only logs in development mode
 * - Removes debug logs in production builds
 * - Preserves real error logging (console.error for actual errors)
 */

const isDevelopment = process.env.NODE_ENV === "development";

/**
 * Logger object with methods that match console API
 */
export const logger = {
  /**
   * Log debug information (only in development)
   */
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Log warnings (only in development)
   */
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  /**
   * Log debug errors (only in development)
   * For actual errors that need to be logged in production, use console.error directly
   */
  error: (...args) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },

  /**
   * Log debug information (only in development)
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  /**
   * Log info (only in development)
   */
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
};

/**
 * Export default logger for convenience
 */
export default logger;
